<template>
  <c-card>
    <router-link v-if="!readOnly" :to="{ name: 'detailsSite', params: { siteId: site._id } }">
      <c-card-img :src="screenshot"/>
    </router-link>
    <c-card-img v-else :src="screenshot"/>
    <c-card-body>
      <c-card-title style="font-size: 1rem">
        <router-link
            v-if="!readOnly"
            :to="{ name: 'detailsSite', params: { siteId: site._id } }"
            v-html="site.name || site.siteAddress"
            class="text-truncate"
            style="display: inline-block; max-width: 100%"
        />
        <span v-else v-html="site.name || site.siteAddress" class="text-truncate"/>
      </c-card-title>
      <c-card-subtitle class="text-truncate" style="display: inline-block; max-width: 100%">{{site.siteAddress}}</c-card-subtitle>
    </c-card-body>
    <c-card-footer>
      <template v-if="!hidePlugins">
        <span>Plugins <strong>{{ site.pluginCount }}</strong></span>
        <a
            v-if="site.updatesRequired"
            class="link float-right"
            href="#"
            @click="updatePlugins"
        >
          Update&nbsp;{{ site.updatesRequired }} plugin{{ site.updatesRequired > 1 ? 's' : '' }}
        </a>
      </template>
      <slot name="footer"/>
    </c-card-footer>
  </c-card>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SiteCard',
  props: {
    site: Object,
    hidePlugins: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    screenshot() {
      return _.get(this.site, 'screenshots.desktop.thumb.url', '/img/no-screenshot.svg');
    },
  },
  methods: {
    updatePlugins() {
      this.$emit('updatePlugins');
    },
  },
};
</script>
